import { atom } from "recoil";
import { GroupedPermissions, PermissionChanged } from "../types";

export const permissionListCheckboxes = atom<GroupedPermissions[]>({
  key: "permissionListCheckboxes",
  default: [],
});

export const permissionSetIsChanged = atom<PermissionChanged[]>({
  key: "permissionSetIsChanged",
  default: [],
});

export const formDirty = atom({
  key: "formDirty",
  default: false,
});
